// extracted by mini-css-extract-plugin
module.exports = {"verify-name-wrapper":"UserFullName_verify-name-wrapper__uyuGp","verify-name-checkbox":"UserFullName_verify-name-checkbox__733wJ"};